interface ICreateUserMessagingTopicParams {
  userId: number;
  purpose: string;
}

export function createUserMessagingTopic({
  userId,
  purpose,
}: ICreateUserMessagingTopicParams) {
  return `user-${userId}__${purpose}`;
}
